export class NoteMessage {
  content: string
  customerVisible: boolean

  constructor(content: string, customerVisible: boolean) {
    this.content = content
    this.customerVisible = customerVisible
  }
}
